<template>
  <div class="contents_header support">
    <div class="txt_box">
      <h5>후원활동</h5>
      <p>
        지역사회의 어려운 이웃들에게 꿈과 희망을 전합니다. <br />
        더불어서 함께 살아가는 세상을 위해 같이 동참하셔서 작은 실천으로 큰
        사랑을 나누어 주세요.
      </p>
    </div>
  </div>

  <div class="support_wrap">
    <div class="support_gallery_wrap">
      <ul class="support_gallery">
        <div class="order_wrap">
          <div class="order_head">
            <h5>진행중인 캠페인 후원하기</h5>
          </div>
          <div class="order_body">
            <div class="check_area">
              <div class="select_box">
                <select name="" id="" class="btn_select" v-model="searchType" @change="handleChange">
                  <option
                    v-for="option in searchOptions"
                    :value="option.value"
                  >{{ option.name }}</option>
                </select>
              </div>
              <ul class="date_filter">
                <li v-for="(day, index) in dayOptions" :key="index" style="margin-right:0px;width:calc((100% - 60px)/5.25);">
                  <a
                    @click="selectDaysAgo(day.value)"
                    :class="{ active: daysAgo === day.value }"
                  >
                    {{ day.text }}
                  </a>
                </li>
              </ul>
              <div class="date_input">
                <input type="date" v-model="startDate" />
                <span>~</span>
                <input type="date" v-model="endDate" />
                <button @click="selectBetweenDate" type="button">조회</button>
              </div>
            </div>
            <div class="tbl_wrap">
              <table>
                <caption>
                  최근 주문내역
                </caption>
                <colgroup>
                  <col style="width: 20%" />
                  <col style="width: 40%" />
                  <col style="width: 20%" />
                  <col style="width: 15%" />
                  <col style="width: 10%" />
                  <col style="width: 15%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>행사일정</th>
                    <th>캠페인명</th>
                    <th>최소 후원액</th>
                    <th>행사장</th>
                    <th>기부화환</th>
                    <th>비 고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="campaign in campaigns"
                    :key="campaign.campaignSeq"
                  >
                    <td>
                      <div class="order_date"
                        v-if="searchType =='funeral'"
                      >{{ checkEndDate(campaign.funeralDate) }}
                      </div>
                      <div class="order_date"
                        v-else
                      >{{ checkEndDate(campaign.eventDate) }}
                      </div>
                      <div class="product_num">({{ campaign.orderNum }})</div>
                    </td>
                    <td>
                      <div class="product_info">
                        <div class="product_photo">
                          <img
                            :src="
                              campaign.filePath
                                ? $getImgUrl(campaign.filePath)
                                : require('../../assets/images/common/campaign_img_01.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="product_tit">
                          <p v-if="campaign.useCampaign">
                            [{{ campaign.categoryName }}]
                          </p>
                          <div>
                            {{
                              campaign.useCampaign
                                ? campaign.campaignName
                                : "기부화환 미적용"
                            }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="product_price">
                        {{
                          campaign.campaignAmount === 0
                            ? "-"
                            : $addComma(campaign.campaignAmount) + "원"
                        }}
                      </div>
                    </td>
                    <td>
                      <div class="place">
                        {{ campaign.eventLocationName }}
                        <span>({{ campaign.eventLocationDtl }})</span>
                      </div>
                    </td>
                    <td>
                      <div class="count">10</div>
                    </td>
                    <td>
                      <a
                        @click="makePayment(campaign.invitationSeq)"
                        class="btn_view"
                        target="_blank"
                        >후원하기</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ul>

      <CustomerServicePagination
        :totalPages = "totalPages()"
        :currentPage = currentPage
        @changePage = "changePage"
      />

    </div>
  </div>
  
</template>
<script>
import { mapActions, mapState } from "vuex";
import CustomerServicePagination from "../common/CustomerServicePagination.vue";

const sponsorModule = "sponsorModule";

export default {
  components: {
    CustomerServicePagination,
  },

  data() {
    return {
      dayOptions: [
        { text: "전체", value: null },
        { text: "오늘", value: 0 },
        { text: "10일", value: 10 },
        { text: "30일", value: 30 },
        { text: "60일", value: 60 },
        { text: "90일", value: 90 },
      ],
      searchOptions: [
        //{ name: '전체', value: 'all' },
        { name: '청첩장', value: 'wedding' },
        { name: '부고장', value: 'funeral' },
      ],
      searchType: 'wedding',
      searchWord: '',
      currentPage: 1,
      currentCategorySeq: "",
      daysAgo: null,
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    };
  },

  methods: {
    ...mapActions(sponsorModule, [
      "requestCampaignSponserListByDaysAgo",
      "requestCampaignSponserListByBetween",
    ]),

    checkEndDate(endDate) {
      if (endDate) {
        return "~ " + endDate;
      }
      //return "상시후원"
    },

    async selectDaysAgo(daysAgo) {
      this.daysAgo = daysAgo;

      const { currentPage, searchType } = this;
      await this.requestCampaignSponserListByDaysAgo({ currentPage, searchType, daysAgo });
    },

    async selectBetweenDate() {
      const { currentPage, searchType, startDate, endDate } = this;
      await this.requestCampaignSponserListByBetween({
        currentPage,
        searchType,
        startDate,
        endDate,
      });
    },

    async handleChange(e) {
      const { currentPage, searchType, daysAgo } = this;
      await this.requestCampaignSponserListByDaysAgo({ currentPage, searchType, daysAgo });
    },

    totalPages() {
      return Math.ceil(this.campaignCount / 4);
    },

    makePayment(invitationSeq) {
      // 클릭한 캠페인 객체 찾기
      const campaign = this.campaigns.find(c => c.invitationSeq === invitationSeq);
      if (!campaign) {
        console.warn('캠페인 정보가 없습니다.');
        return;
      }
      const paymentAmount = campaign.campaignAmount;
      const campaignName = campaign.campaignName;
      const orderNum = campaign.orderNum;

      // 결제 페이지로 이동
      const routeData = this.$router.resolve({
        name: 'PaymentModalApiPage',
        params: { orderNum }
      });
      window.open(routeData.href, '_blank');

    },

    async changePage (page) {
      this.currentPage = page
      const {currentPage, searchType, currentCategorySeq} = this
      await this.requestCampaignSponserListByDaysAgo({currentPage, searchType, currentCategorySeq})
    }
  },

  computed: {
    ...mapState(sponsorModule, ["campaigns", "campaignCount"]),
  },

  async mounted() {
    const { currentPage, searchType, daysAgo } = this;
    await this.requestCampaignSponserListByDaysAgo({ currentPage, searchType, daysAgo });
  },
};
</script>
<style lang=""></style>
